import axios from 'axios';
import { memoize } from 'lodash';

import { SiteSettings } from '@gn-audio/jss-core/site-settings/models';

import {
  FeatureList,
  FeaturesSettings,
  SiteFeature,
  SiteSettingsScope,
} from 'api/siteSettings/siteSettings.model';
import { logServerError } from 'utils/logger';

// Generic function to fetch site settings
export const getSiteSettings = async (
  baseUrl: string,
  language: string,
  scope: SiteSettingsScope | SiteSettingsScope[]
): Promise<SiteSettings> => {
  try {
    const scopes = Array.isArray(scope) ? scope.join(',') : scope;
    const url = `${baseUrl}/settings?site=jabra&marketLocale=${language}&scope=${scopes}`;
    const res = await axios.get<SiteSettings>(url);
    return res.data;
  } catch (error) {
    logServerError(error);
    throw error;
  }
};

export const getFullSiteSettings = memoize(
  async (baseUrl: string, language: string): Promise<SiteSettings> => {
    const settingScopes = [
      SiteSettingsScope.Ecom,
      SiteSettingsScope.Display,
      SiteSettingsScope.Sfcc,
      SiteSettingsScope.Authorization,
      SiteSettingsScope.MyJabra,
      SiteSettingsScope.Shipping,
      SiteSettingsScope.Returns,
      SiteSettingsScope.Cart,
    ];
    return getSiteSettings(baseUrl, language, settingScopes);
  }
);

// Fetch site features
export const getSiteFeatures = async (
  baseUrl: string,
  language: string
): Promise<FeaturesSettings> => {
  try {
    const features = Object.values(SiteFeature).join(',');
    const url = `${baseUrl}/feature/jabra/${language}?features=${features}`;
    const res = await axios.get<FeatureList>(url);

    return res.data.reduce((settings, feature) => {
      return { ...settings, [feature.name]: feature.value };
    }, {});
  } catch (error) {
    logServerError(error);
    return {};
  }
};
